import type { ReactNode } from 'react'

/**
 * Free-space split above/below the error block.
 * Top:bottom = 2:5 → content sits after ~29% of leftover viewport height
 * (upper third), accounting for real content height on any device.
 */
const ERROR_STATE_TOP_SPACE_GROW = 2
const ERROR_STATE_BOTTOM_SPACE_GROW = 5

type PlansErrorStateLayoutProps = {
  children: ReactNode
  className?: string
}

export function PlansErrorStateLayout({ children, className }: PlansErrorStateLayoutProps) {
  const rootClassName =
    className != null && className.length > 0
      ? `flex min-h-[100vh] flex-col px-5 ${className}`
      : 'flex min-h-[100vh] flex-col px-5'

  return (
    <div className={rootClassName}>
      <div
        className="min-h-0"
        style={{ flexGrow: ERROR_STATE_TOP_SPACE_GROW }}
        aria-hidden
      />
      <div className="mx-auto flex w-full max-w-[279px] shrink-0 flex-col items-center">
        {children}
      </div>
      <div
        className="min-h-0"
        style={{ flexGrow: ERROR_STATE_BOTTOM_SPACE_GROW }}
        aria-hidden
      />
    </div>
  )
}
